import { updateConfigUser } from 'common/api/v1/users';
import showToast from 'common/utils/showToast';

import fetchData from '../../profile/actions/fetchData';
import {
    SAVE_PREFERENCE,
    SAVE_PREFERENCE_FAILURE,
    SAVE_PREFERENCE_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (value) => (dispatch) => {
    const payload = {
        preset_scope_preference: value,
    };

    dispatch(actions[SAVE_PREFERENCE]());

    return updateConfigUser(payload)
        .then(() => {
            dispatch(actions[SAVE_PREFERENCE_SUCCESS]());
            dispatch(fetchData());
            showToast();
        })
        .catch((error) =>
            dispatch(
                actions[SAVE_PREFERENCE_FAILURE](error?.response?.data?.errors),
            ),
        );
};
